import React from 'react';
import { ExternalLink } from 'lucide-react';

const YoutubeLinkCard = ({ metadata }) => {
  // Extract YouTube URL and video info from metadata
  const youtubeUrl = metadata?.url || metadata?.youtube_url || metadata?.video_url;
  const videoTitle = metadata?.title || metadata?.video_title || 'Open Video';
  
  // Extract YouTube video ID from URL
  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    
    // Handle different YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/,
      /youtube\.com\/embed\/([^&\n?#]+)/,
      /youtube\.com\/v\/([^&\n?#]+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  };
  
  const videoId = getYouTubeVideoId(youtubeUrl);
  const thumbnail = videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : null;
  
  if (!youtubeUrl) {
    return null;
  }
  
  return (
    <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800 overflow-hidden">
      
      {/* Thumbnail (if available) */}
      {thumbnail && (
        <div className="relative w-full aspect-video bg-gray-100 dark:bg-neutral-900">
          <img 
            src={thumbnail} 
            alt={videoTitle}
            className="w-full h-full object-cover"
            onError={(e) => {
              // Hide image if it fails to load
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}
      
      {/* Video Title Link */}
      <div className="px-3 py-2">
        <a 
          href={youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-start text-sky-600 dark:text-sky-400 hover:text-sky-800 dark:hover:text-sky-300 text-sm transition-colors group"
        >
          <ExternalLink className="w-4 h-4 mr-2 flex-shrink-0 mt-0.5" />
          <span className="line-clamp-2 group-hover:underline">{videoTitle}</span>
        </a>
      </div>
    </div>
  );
};

export default YoutubeLinkCard;

